import BASE_URL from "../config";

const json = async (response) => {
  const result = await response.json().catch(() => ({}));
  return { ok: response.ok, status: response.status, ...result };
};

// Cheap products offered at checkout. Empty when the admin has not set an add-on price limit.
export const getAddOns = async (excludeIds = []) => {
  try {
    const query = excludeIds.length ? `?exclude=${encodeURIComponent(excludeIds.join(","))}` : "";
    const result = await json(await fetch(`${BASE_URL}/products/addons${query}`));
    return result.ok && result.success && Array.isArray(result.data) ? result.data : [];
  } catch {
    return [];
  }
};

// One-click COD confirmation: the token comes from the link sent to the customer.
export const getCodConfirmation = async (token) => {
  try {
    return await json(await fetch(`${BASE_URL}/orders/confirm/${encodeURIComponent(token)}`));
  } catch {
    return { ok: false, success: false, message: "Network error - please try again." };
  }
};

export const confirmCodOrder = async (token) => {
  try {
    return await json(await fetch(`${BASE_URL}/orders/confirm/${encodeURIComponent(token)}`, { method: "POST" }));
  } catch {
    return { ok: false, success: false, message: "Network error - please try again." };
  }
};
